module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Databeskyttelse",
	"footer.privacy.url": "https://www.grohe.dk/da_dk/databeskyttelse.html",
	"footer.disclaimer.text": "Juridisk information",
	"footer.disclaimer.url": "https://www.grohe.dk/da_dk/aftryk.html",
	"footer.copyright": "&copy; 2017 GROHE",
	"homepage.headline": "GROHE Brusekonfigurator",
	"homepage.introtext": "Du kan finde det rette GROHE SmartControl brusesystem for dig ved at besvare nogle spørgsmål i konfiguratoren herunder.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Siden blev desværre ikke fundet",
	"404.link.goBack": "Gå tilbage til hjemmeside",
	"configurator.button.seeResults": "Se resultatet",
	"question1.question": "Hvilken type brusesystem har du brug for?",
	"question1.option1.text": "Bruser",
	"question1.option2.text": "Bad",
	"question2.question": "Hvilken installation foretrækker du? Uden på væggen eller indbyg?",
	"question2.option1.text": "Installation af bruser og termostat på væggen",
	"question2.option2.text": "Installation af termostat på væggen med indbygget brusestang",
	"question2.option3.text": "Indbyggede installationer",
	"question3.question": "Hvordan ønsker du at kontrollere dit brusesystem?",
	"question3.option1.text": "Med SmartControl's tryk og drej system og en termostat",
	"question3.option2.text": "På almindelig vis inklusiv en termostat",
	"question3.option3.text": "Med en etgrebstermostat",
	"question3.option4.text": "Med omskiftersystem",
	"question4.question": "Hvad ønsker du at være i stand til at kontrollere når du bruser?",
	"question4.option1.text": "Kun håndbruseren",
	"question4.option2.text": "En stor hovedbruser (150-250mm) og en håndbruser",
	"question4.option3.text": "Et ekstra stort brusehoved (250-400mm) og en håndbruser",
	"question4.option4.text": "En stor hovedbruser (150-250mm), en håndbruser og en kartud",
	"question4.option5.text": "Et ekstra stort brusehoved (250-400mm), en håndbruser og en kartud",
	"question5.question": "Hvilket design foretrækker du?",
	"question5.option1.text": "Firkant",
	"question5.option2.text": "Rund",
	"question6.question": "Hvor mange vandtilførsler har du brug for?",
	"question6.option1.text": "Tre: Hovedbruser med 2 spraymønstre og en håndbruser",
	"question6.option2.text": "Tre: Hovedbruser med 2 spraymønstre og en håndbruser",
	"question6.option3.text": "Tre: Hovedbruser, håbndbruser og kartud",
	"question6.option4.text": "Tre: Hovedbruser, side- og håndbruser",
	"question6.option5.text": "To: Hovedbruser og håndbruser ",
	"question6.option6.text": "To: Håndbruser og kartud",
	"question6.option7.text": "En: Kun en håndbruser",
	"question6.option8.text": "En: Kartud",
	"question7.question": "Vælg din farve",
	"question7.option1.text": "Krom",
	"question7.option2.text": "Hvid/krom",
	"question7.option3.text": "Hvid/krom",
	"question8.question": "Vil du have et trim-sæt med integreret holder til håndbruseren?",
	"question8.option1.text": "Ja, med integreret holder til håndbruseren",
	"question8.option2.text": "Nej, jeg vil købe en separat holder til håndbruseren",
	"question9.question": "Har du brug for en brusestang eller et vægholdersæt?",
	"question9.option1.text": "Brusestang",
	"question9.option2.text": "Vægholdersæt",
	"question10.question": "Kan du bedst lide en vægmonteret eller loftsmonteret hovedbruser?",
	"question10.option1.text": "Vægmonteret hovedbruser",
	"question10.option2.text": "Loftsmonteret hovedbruser",
	"results.title": "{productGroupsCount, plural, \none {Dit resultat} \nother {Dine resultater}\n}",
	"results.proposal.title": "Forslag {number}",
	"results.proposal.title.single": "Forslag",
	"results.bundle.title": "For at installere brusesystemet korrekt har du også brug for:",
	"results.newConfiguration.title": "Vil du forsøge igen?",
	"results.newConfiguration.buttonText": "Start konfiguratoren forfra",
	"results.product.number": "Produktnummer:  #{number}",
	"results.product.button.productInformation": "Produktinformation",
	"results.product.button.dealerLocator": "Find et showroom i nærheden af dig",
	"results.product.button.buyNow": "Køb online",
	"results.product.button.downloadPDF": "Download forslag (PDF)",
	"results.product.information": "Produktdetails",
	"results.product.dealer": "Find et showroom i nærheden af dig",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"app.components.HomePage.header": "GROHE SmartControl Konfigurator",
	"app.components.NotFoundPage.header": "Seite nicht gefunden"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.da_dk.json
// module id = 746
// module chunks = 0